import { PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { AutomationSource } from 'api/automation-builder/types';
import { floatUid } from 'utils/uid';
import { ProjectTemplateStore } from '..';
import {
  CreateAutomationForSourceActionPayload,
  ToggleEnabledStateForAutomationByIdPayload,
  UpdateAllAutomationsPayload,
  UpdateAutomationById,
} from '../actions';

export const automationSlice = {
  updateAllAutomations(
    state: ProjectTemplateStore,
    { payload }: PayloadAction<UpdateAllAutomationsPayload>,
  ) {
    const templateId = state.activeId;

    if (templateId) {
      const activeTemplate = state.data[templateId?.toString()];

      activeTemplate.template.automations = payload.automations;
    }

    return state;
  },

  updateAutomationById(
    state: ProjectTemplateStore,
    { payload }: PayloadAction<UpdateAutomationById>,
  ) {
    const templateId = state.activeId;

    if (templateId) {
      const activeTemplate = state.data[templateId?.toString()];

      // Not spreading here to pass the null check
      if (activeTemplate?.template?.automations) {
        const _automationInArray = activeTemplate.template.automations.find(
          (e) => e.automationId === payload.automationId,
        );

        if (_automationInArray) {
          const index =
            activeTemplate.template.automations.indexOf(_automationInArray);

          activeTemplate.template.automations[index] = _.cloneDeep(
            payload.automation,
          );
        }
      } else {
        activeTemplate.template.automations = [payload.automation];
      }
    }

    return state;
  },

  toggleEnabledStateForAutomationById(
    state: ProjectTemplateStore,
    { payload }: PayloadAction<ToggleEnabledStateForAutomationByIdPayload>,
  ) {
    const templateId = state.activeId;

    if (templateId) {
      const activeTemplate = state.data[templateId?.toString()];

      if (activeTemplate && activeTemplate?.template?.automations) {
        const automations = activeTemplate?.template?.automations;
        const automation = automations.find(
          (e) => e.automationId === payload.automationId,
        );

        if (automation) {
          const index = automations.indexOf(automation);

          activeTemplate.template.automations[index].enabled = payload.state;
        }
      }
    }

    return state;
  },

  createAutomationForSource(
    state: ProjectTemplateStore,
    { payload }: PayloadAction<CreateAutomationForSourceActionPayload>,
  ) {
    const templateId = state.activeId;

    if (templateId) {
      const activeTemplate = state.data[templateId?.toString()];

      const newAutomationId = -1 * floatUid();
      const newAutomation = _.set(
        _.cloneDeep(payload.automation),
        'automationId',
        newAutomationId,
      );

      if (payload.source === AutomationSource.ProjectPhaseTemplate) {
        _.set(
          newAutomation,
          'tags.phaseTemplateInstanceReferenceId',
          payload.sourceId,
        );
      } else if (payload.source === AutomationSource.TaskTemplate) {
        _.set(
          newAutomation,
          'tags.taskTemplateInstanceReferenceId',
          payload.sourceId,
        );
      }

      if (activeTemplate.template.automations) {
        activeTemplate.template.automations =
          activeTemplate.template.automations.concat([newAutomation]);
      } else {
        activeTemplate.template.automations = [newAutomation];
      }
    }

    return state;
  },
};
